import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import MarqueeStrip from "@/components/landing/MarqueeStrip";
import Services from "@/components/landing/Services";
import Blanks from "@/components/landing/Blanks";
import Polos from "@/components/landing/Polos";
import Hoodies from "@/components/landing/Hoodies";
import Oversized from "@/components/landing/Oversized";
import Workwear from "@/components/landing/Workwear";
import Portfolio from "@/components/landing/Portfolio";
import Process from "@/components/landing/Process";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import FloatingCall from "@/components/landing/FloatingCall";
import StructuredData from "@/components/landing/StructuredData";

export default function Home() {
  return (
    <div className="App font-body" data-testid="landing-root">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Services />
        <Blanks />
        <Polos />
        <Hoodies />
        <Oversized />
        <Workwear />
        <Portfolio />
        <Process />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingCall />
      <StructuredData />
    </div>
  );
}
